import { useTenant } from '#imports';
import { reduce } from 'lodash-es';

export const useAdminTenant = () => {
  const tenant = useTenant();
  const currentTenant = useState('currentTenant',() => undefined);
  const currentTenantMenuItems = useState('currentTenantMenuItems', () => undefined);
  const tenantList = useState('tenantList', () => ([]));
  const adminMenuItems = useState('adminMenuItems', () => ([]));

  const fetchTenantList = async () => {
    if(tenant!='admin') return [];
    try{
      const res:any= await useTenantFetch('/api/admin/tenants',{
        async: true,
      });
      tenantList.value = res.data;
      return;
    }catch(err) {
      log(err);
    }
    return [];
  };

  const fetchTenantMenuItems = async () => {
    if(!currentTenant.value) return [];

    try{
      const res:any= await useTenantFetch(`/api/admin/tenants/${currentTenant.value}/dynamics`,{
        async: true,
      });
      currentTenantMenuItems.value = res.data;
      return;
    }catch(err) {
      log(err);
    }
    return [];
  };
  

  watch(currentTenant, async () => {
    fetchTenantList();
    fetchTenantMenuItems();
  },{ immediate: true });

  return {
    currentTenant,
    currentTenantMenuItems,
    tenantList,
    adminMenuItems,
    fetchTenantList,
    fetchTenantMenuItems,
  };
};	